export const tg = window.Telegram?.WebApp;
let mainButtonHandler = null;

export function isTelegram() {
  return !!tg?.initData;
}

export function getTelegramUser() {
  return tg?.initDataUnsafe?.user || null;
}

export function expandApp() {
  tg?.expand();
}

export function closeMiniApp() {
  tg?.close();
}

export function setBackButton(onClick) {
  if (!tg) return;
  tg.BackButton.show();
  tg.BackButton.onClick(onClick);
}

export function hideBackButton(onClick) {
  if (onClick) tg?.BackButton.offClick?.(onClick);
  tg?.BackButton.hide();
}

export function setMainButton(text, onClick) {
  if (!tg?.MainButton) return;
  if (mainButtonHandler) tg.MainButton.offClick?.(mainButtonHandler);
  mainButtonHandler = typeof onClick === 'function' ? onClick : null;
  tg.MainButton.setText(text);
  tg.MainButton.show();
  if (mainButtonHandler) tg.MainButton.onClick(mainButtonHandler);
}

export function hideMainButton() {
  if (mainButtonHandler) tg?.MainButton?.offClick?.(mainButtonHandler);
  mainButtonHandler = null;
  tg?.MainButton?.hide?.();
}

export const DEV_TELEGRAM_ID = process.env.REACT_APP_DEV_TELEGRAM_ID || '123456789';
